export const useBookmarks = () => {
  const store = useStore();

  const userFavorites = computed(() => store.getters['profile/getByField']('userFavorites'));

  const addFavorite = async (id, entityName) => {
    const route = useRoute();
    if (route.path !== FAVOURITES_URL) {
      store.dispatch('profile/setAnyFavWithoutRead', true);
    }
    await store.dispatch('profile/postFavorite', {
      entity: entityName,
      updated_at: new Date(),
      id_entity: id.toString()
    });
  };
  const removeFavorite = async (id, entityName) =>
    await store.dispatch('profile/removeFavorite', { entity: entityName, id_entity: id });

  return {
    addFavorite,
    userFavorites,
    removeFavorite
  };
};
